import { Directive, forwardRef, Input } from '@angular/core';
import { SelectOptionBase } from './select-option-base';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'soft-select-option-header',
  standalone: true,
  providers: [
    {
      provide: SelectOptionBase,
      useExisting: forwardRef(() => SelectOptionHeaderDirective),
    },
  ],
})
export class SelectOptionHeaderDirective extends SelectOptionBase {
  @Input() id?: string;
  @Input() text?: string;

  constructor() {
    super();
  }
}
